import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=52869575&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=52869575&prod&lang=scss"
import style1 from "./contact.vue?vue&type=style&index=1&id=52869575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52869575",
  null
  
)

export default component.exports